import t from "react";
var o = /* @__PURE__ */ t.createContext({});
export {
  o as selectContext
};
